module.exports = __webpack_public_path__ + "static/img/wl_yjgk.dc5c874.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/busSupport/wl_yjgk.png
// module id = i/qG
// module chunks = 1